exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".progress-container-1SsfpfuYmwr{display:flex;overflow:hidden;position:relative;left:0;top:0;z-index:3;width:100%;height:3px;margin-bottom:-3px;flex:0 0 auto}@media (max-width: 767px){html[data-supports-mobile=true] .progress-container-1SsfpfuYmwr{position:fixed}}.progress-bar-5HzFZFQDmwr{position:absolute;top:0;left:0;height:100%;width:100%;transition:transform cubic-bezier(0.165, 0.84, 0.44, 1),opacity linear,background linear;transform-origin:left;transform:scaleX(0);opacity:0}.progress-bar-blue-6UYZs3KSmwr{background:#006fc8}.progress-bar-light-gray-2EaNuWeDmwr{background:var(--hint-text)}.progress-below-7cJseDn3mwr{top:0px}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"container": "progress-container-1SsfpfuYmwr",
	"bar": "progress-bar-5HzFZFQDmwr",
	"bar-blue": "progress-bar-blue-6UYZs3KSmwr",
	"barBlue": "progress-bar-blue-6UYZs3KSmwr",
	"bar-light-gray": "progress-bar-light-gray-2EaNuWeDmwr",
	"barLightGray": "progress-bar-light-gray-2EaNuWeDmwr",
	"below": "progress-below-7cJseDn3mwr"
};